import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { ToastProvider } from '@/componentes/Toast'
import { crearQueryClient } from '@/datos/consultas'
import { destinoCanonico } from '@/lib/dominio'
import { escucharErroresDeDescarga } from '@/lib/recarga'
import { SesionProvider } from '@/datos/sesion'
import { rutas } from '@/rutas'
import '@/styles/index.css'

const destino = destinoCanonico(window.location.href)
if (destino) {
  window.location.replace(destino)
} else {
  montar()
}

function montar() {
  // En producción Vite avisa antes de lanzar el error de descarga: recarga una vez (#64).
  escucharErroresDeDescarga()
  const router = createBrowserRouter(rutas)
  const queryClient = crearQueryClient()

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <SesionProvider>
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </SesionProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}
